import axios from "axios";
import Config from "@/config";
import store from "../store/index.js"

export default class TicketService {
    postNewTicket(accesstoken, ticketSubject, ticketContent){
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} }
        };

        let bodyTosend = {
            "subject": ticketSubject,
            "issue": ticketContent,
            "group": "627295145b5bcec3fda65ba2",
            "type": "62704527eb80da078e1c2e0b",
            "priority": "6270452eb252dd96354f8712"
        }
        return axios
            .post(
                Config.proxy + Config.url("ticket") + "create",
                bodyTosend,
                options
            )
            .then(res => res.status)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }

    async getTickets(accesstoken, email){
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} }
        };

        let ticketsObject = await axios
                .get(
                    Config.proxy + Config.url("ticket"),
                    options
                )
                .then(res => res.data)
                .catch(
                    function (error) {
                    console.log('Show error notification!')
                    return Promise.reject(error)
                    }
                )
        return this.formatTickets(ticketsObject, email)
    }

    sendComment(accesstoken, body, ticketId){
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} }
        };
        const bodyToSend ={
            "_id": ticketId,
            "comment": body
        }

        return axios
        .post(
            Config.proxy + Config.url("ticket") + "addcomment",
            bodyToSend,
            options
        )
        .then(res => res.data)
        .catch(
            function (error) {
            console.log('Show error notification!')
            return Promise.reject(error)
            }
        )
    }

    formatTickets(ticketsObject, ownerEmail){
        let userTicketsObject = ticketsObject.filter(ticket => ticket.owner.email == ownerEmail);
        store.commit("tickets/setTicketsList", userTicketsObject);
        let ticketArray = [];
        userTicketsObject.forEach(ticket => {
            let formattedTicket = {};
            formattedTicket.uid = ticket.uid;
            formattedTicket.created = new Date(ticket.date).toLocaleDateString();
            formattedTicket.status = ticket.status;
            formattedTicket.updated = ticket.updated ? new Date(ticket.updated).toLocaleDateString() : "-";
            formattedTicket.closed = ticket.closedDate ? new Date(ticket.closedDate).toLocaleDateString() : "-";
            formattedTicket.subject = ticket.subject;
            formattedTicket.issue = this.parseHtmlIssue(ticket.issue);
            ticketArray.push(formattedTicket)
        });
        return ticketArray;
    }
    parseHtmlIssue(issue){
        issue = issue.replace(/(<([^>]+)>)/g, "\n")
        return issue
    }
}